/**
 * Featured Collection New - Swiper Initialization
 * Handles Swiper slider initialization for featured collection sections
 */

document.addEventListener('DOMContentLoaded', function(){
  // Initialize all featured collection new sections
  const sections = document.querySelectorAll('[id^="featured-collection-new-"]');
  
  sections.forEach(function(section) {
    initFeaturedCollectionNew(section);
  });
});

function initFeaturedCollectionNew(root) {
  if (!root) return;

  const swiperContainers = root.querySelectorAll('.fc-swiper');
  
  // Wait for Swiper to be available
  function initSwiper() {
    if (swiperContainers.length && typeof Swiper !== 'undefined') {
      swiperContainers.forEach(function(wrapper) {
        const perMobile = parseFloat(wrapper.getAttribute('data-per-mobile')) || 1.2;
        const colsDesktop = parseInt(wrapper.getAttribute('data-cols-desktop')) || 4;
        const gapMobile = parseInt(wrapper.getAttribute('data-gap-mobile')) || 10;
        const gapDesktop = parseInt(wrapper.getAttribute('data-gap-desktop')) || 16;
        const arrows = wrapper.getAttribute('data-arrows') === 'true';
        const dots = wrapper.getAttribute('data-dots') === 'true';
        
        
        const swiperEl = wrapper.querySelector('.swiper');
        if (!swiperEl) return;

        // Count total slides
        const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

        // Check if we're on desktop
        const isDesktop = window.innerWidth >= 768;
        
        const swiperConfig = {
          slidesPerView: isDesktop ? colsDesktop : perMobile,
          spaceBetween: isDesktop ? gapDesktop : gapMobile,
          loop: false,
          allowTouchMove: true,
          breakpoints: {
            0: {
              slidesPerView: perMobile,
              spaceBetween: gapMobile
            },
            768: {
              slidesPerView: colsDesktop,
              spaceBetween: gapDesktop
            },
            1024: {
              slidesPerView: colsDesktop,
              spaceBetween: gapDesktop
            }
          }
        };

        if (arrows) {
          const nextEl = wrapper.querySelector('.swiper-button-next');
          const prevEl = wrapper.querySelector('.swiper-button-prev');
          if (nextEl && prevEl) {
            swiperConfig.navigation = {
              nextEl: nextEl,
              prevEl: prevEl
            };
          }
        }
        
        if (dots) {
          const paginationEl = wrapper.querySelector('.swiper-pagination');
          if (paginationEl) {
            swiperConfig.pagination = {
              el: paginationEl,
              clickable: true
            };
          }
        }

        new Swiper(swiperEl, swiperConfig);
      });
    } else {
      // Retry if Swiper not loaded yet
      setTimeout(initSwiper, 100);
    }
  }

  // Initialize Swiper
  initSwiper();
}
